import React, { useRef, useEffect, useState } from 'react'
import { View, Text, Image, StyleSheet } from 'react-native'
import { initialGameInfo } from '../../App'
import { carbonbars } from '../../assets/carbonbar'
import { medals } from '../../assets/medal'
import Animated, { useSharedValue, withTiming, useFrameCallback, Easing, useAnimatedStyle } from 'react-native-reanimated'
import { playSound } from '../../utils/AudioPlayer'

import PropTypes from 'prop-types'

const Feedback = ({ gameInfo }) => {
  const hasBeenCalled = useRef(false)

  const [countSavings, setCountSavings] = useState(0)
  const [countReductions, setCountReductions] = useState(0)
  const [showMedal, setShowMedal] = useState(false)
  const [medal, setMedal] = useState(medals[0])

  const savingsValue = useSharedValue(0)
  const reductionsValue = useSharedValue(0)

  function getRating () {
    if (gameInfo.totalReductions > 19 && gameInfo.totalSavings > 18) {
      return 3
    } else if (gameInfo.totalReductions > 15 && gameInfo.totalSavings > 14) {
      return 2
    } else if (gameInfo.totalReductions > 11) {
      return 1
    }
    return 0
  }

  const frameCallback = useFrameCallback((frameInfo) => {
    setCountSavings(Math.ceil(savingsValue.value))
    setCountReductions(Math.ceil(reductionsValue.value))
  })

  const animatedStyle = useAnimatedStyle(() => {
    const height = reductionsValue.value / initialGameInfo.co2ReductionsMax * styles.co2InfoBarContainer.height
    return {
      height,
      borderBottomLeftRadius: height > 86 ? height - 86 : 0,
      borderBottomRightRadius: height > 86 ? height - 86 : 0
    }
  })

  useEffect(() => {
    if (hasBeenCalled.current) return
    hasBeenCalled.current = true

    frameCallback.setActive(true)

    savingsValue.value = withTiming(gameInfo.totalSavings, {
      duration: 100 * gameInfo.totalSavings,
      easing: Easing.inOut(Easing.linear)
    })

    reductionsValue.value = withTiming(gameInfo.totalReductions, {
      duration: 100 * gameInfo.totalReductions,
      easing: Easing.inOut(Easing.linear)
    })

    if (getRating() > 0) {
      playSound(require('../../assets/sounds/endgame_victory.mp4'))
    } else {
      playSound(require('../../assets/sounds/endgame_fail.mp4'))
    }

    setTimeout(() => {
      if (getRating() > 0) {
        playSound(require('../../assets/sounds/endgame_victory_award.mp4'))
      } else {
        playSound(require('../../assets/sounds/endgame_fail_stamp.mp4'))
      }
      setMedal(medals[getRating()])
      setShowMedal(true)
    }, 3000)
  }, [])

  return (
    <View id={'content'} style={[styles.content]}>
      <Text style={styles.h1}>KIITOS PELAAMISESTA!</Text>
      <Text style={styles.center}>Kymmenen vuotta kunnanvaltuustossa on päättynyt.</Text>
      <Text style={styles.h2}>SAIT VÄHENNETTYÄ KAUPUNGIN PÄÄSTÖJÄ:</Text>
      <View style={styles.feedbackCO2}>
        <Image style={styles.co2Icon} source={require('../../assets/symbols/co2_cloud.png')} />
        <View style={styles.co2InfoBarContainer}>
          <Image key={'carbonBar'} style={styles.co2InfoBarFeedback} source={ carbonbars[23] } />
          <Animated.View style={[styles.co2mask, animatedStyle]}></Animated.View>
        </View>
        <View style={styles.feedbackCO2Text}>
          <Text style={styles.carbonReduction} >{countReductions * 2}%</Text>
          <Text style={styles.feedbackTextMax}>(MAX 46%)</Text>
        </View>
      </View>
      <View style={styles.feedbackSavings}>
        <Text style={styles.h2}>SAIT KERÄTTYÄ SÄÄSTÖJÄ:</Text>
        <Text style={[styles.feedbackBigText]}>{countSavings},000,000 €</Text>
        <Text style={styles.feedbackTextMax}>(MAX 22,000,000 €)</Text>
      </View>
      { showMedal &&
        <Image style={styles.medal} source={medal} />
      }
    </View>
  )
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    width: '100%',
    alignItems: 'center'
  },
  footer: {
    height: 81,
    width: '100%',
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 40
  },
  headerImg: {
    marginTop: 20,
    width: 262,
    height: 19
  },
  h1: {
    fontFamily: 'OpenSans_700Bold',
    fontSize: 30,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  center: {
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: 18
  },
  h2: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center'
  },
  feedbackCO2: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20
  },
  co2Icon: {
    marginRight: 20,
    marginBottom: 10,
    width: 98,
    height: 54
  },
  co2InfoBarContainer: {
    marginRight: 20,
    width: 21,
    height: 96
  },
  co2InfoBarFeedback: {
    position: 'absolute',
    width: 21,
    height: 96,
    top: 0,
    left: 0
  },
  co2mask: {
    position: 'absolute',
    backgroundColor: 'rgb(36, 68, 75)',
    borderColor: '#587982',
    borderWidth: 2,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    width: 21,
    height: 0,
    top: 0,
    left: 0
  },
  feedbackCO2Text: {
    flexDirection: 'column',
    display: 'flex'
  },
  carbonReduction: {
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'black',
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: 32,
    marginRight: 5
  },
  feedbackTextMax: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    fontSize: 16,
    fontWeight: 'bold',
    color: 'black'
  },
  feedbackSavings: {
    alignItems: 'center',
    marginBottom: 20
  },
  feedbackBigText: {
    fontSize: 32,
    fontWeight: 'bold',
    marginBottom: 10,
    fontFamily: 'Arial, Helvetica, sans-serif',
    color: 'black'
  },
  medal: {
    width: 135,
    height: 127
  }
})

export default Feedback

Feedback.propTypes = {
  gameInfo: PropTypes.object.isRequired
}
